import { useEffect, useState, type ReactNode } from "react";

export interface ConnectionLogoProps {
  logoUrl?: string | null;
  className?: string;
  fallback?: ReactNode;
}

const ConnectionLogo = ({ logoUrl, className, fallback }: ConnectionLogoProps): JSX.Element => {
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [logoUrl]);

  return (
    <span className={className} aria-hidden="true">
      {logoUrl && !imageFailed ? (
        <img
          src={logoUrl}
          alt=""
          onError={() => setImageFailed(true)}
        />
      ) : fallback ?? null}
    </span>
  );
};

export default ConnectionLogo;
